import { createFileRoute } from '@tanstack/react-router'

import SitePageDispatcher from 'pages/Site/SitePageDispatcher'

export const Route = createFileRoute('/_auth/sites/$id/')({
  component: SitePageDispatcher,
})
